import item5 from './dh.webp';
import item1 from './fun-radio.webp';
import item8 from './gva.webp';
import item6 from './LaLibre1.webp';
import nb from './nb.webp';
import item4 from './rtbf.webp';
import item7 from './rtl-info.webp';
import trends from './trends.webp';
import item3 from './vivacite-namur.webp';

export const images = [trends, nb, item1, item3, item4, item5, item6, item7, item8];
